import config from "@/config"
import http from "@/utils/request"
export default {
	GenerateLiquidationInfo: {
	    url: `${config.API_URL}/LiquidationInfo/GenerateLiquidationInfo`,
	    name: "当面付",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	LiquidationPay: {
	    url: `${config.API_URL}/LiquidationInfo/LiquidationPay`,
	    name: "当面付",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
}
